import { useEffect, useRef } from "react"

export default function useSleep() {
  const timerRef = useRef<number[]>([])

  useEffect(() => () => timerRef.current.forEach(window.clearTimeout), [])

  return (ms: number) =>
    new Promise((done) => {
      timerRef.current.push(window.setTimeout(done, ms))
    })
}
